<template>
  <div
    :class="scrollTop ? '' : 'scrollEd'"
    class="topBarContainer flexBetween"
    :style="{
      backgroundColor: `rgba(255, 255, 255,${
        scrollTop ? scrollTop / (scrollTop + 20) : 0
      }`,
    }"
  >
    <div
      class="pageTitle"
      :style="{
        opacity: `${scrollTop ? scrollTop / (scrollTop + 20) : 0}`,
      }"
    >
      {{ title }}
    </div>
    <div class="tool-wrap" :class="black ? 'tool-wrap-black' : ''">
      <i class="iconfont icon-xiaochengxufenxiang" @click="share"></i>
      <i class="line"></i>
      <i class="iconfont icon-xiaochengxu-guanbi" @click="goBack"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToolWrap",
  props: {
    black: Boolean,
    title: String,
  },
  data() {
    return {
      scrollTop: null,
    };
  },
  methods: {
    goBack() {
      SmartCity.goBack();
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.querySelector(".topBarContainer").offsetTop;
      if (offsetTop !== null && scrollTop) {
        this.scrollTop = scrollTop;
        // console.log("scrollTop" + scrollTop);
        // 通过opacity
        // let opacity = this.scrollTop / 140;
        // opacity = opacity > 1 ? 1 : opacity;
        // if (this.scrollTop > 20) {
        //   this.opacityStyle = { opacity };
        // } else {
        //   this.opacityStyle = { opacity: 0 };
        // }
      }
      if (scrollTop == 0) {
        this.scrollTop = 0;
      }
    },
    share() {
      SmartCity.shareTo({
        title: `2022年“最美湖州人”候选人公示投票`,
        contentURL:
          "https://prod-app-frontend.zhijianmedia.cn/piano-vote/#/Vote",
        brief: "等你来投票",
        imageLink:
          "https://oss2upload.zhijianmedia.cn/common/0_2022121122464942085782905.jpeg",
      });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less" scoped>
.scrollEd {
  .tool-wrap {
    color: #fff;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.4);
    border: 1px solid #ccc;
  }
}
.pageTitle {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
.topBarContainer {
  width: calc(100vw);
  height: 80px;
  padding: 35px 15px 0;
  position: fixed;
  z-index: 1000;
  top: 0;
  background: transparent;
  // border-bottom: 1px solid #eaeaea;
}
.tool-wrap {
  display: flex;
  align-items: center;
  padding: 0 14px;
  height: 28px;
  line-height: 28px;
  position: absolute;
  right: 20px;
  top: 42px;
  background: #ffffff66;
  color: #666;
  font-size: 16px;
  border-radius: 20px;
  text-align: center;

  z-index: 1000;
  border: 1px solid #f2f2f2;

  .line {
    border-right: 1px solid #f2f2f2;
    height: 20px;
    margin: 2px 10px;
  }

  i:nth-child(1) {
    font-size: 20px;
  }
}

.tool-wrap-black {
  position: absolute;
  right: 20px;
  top: 46px;
  background: rgba(0, 0, 0, 0.4);

  color: #fff;
  font-size: 16px;
  border-radius: 20px;
  text-align: center;
  padding: 0 14px;
  height: 28px;
  line-height: 28px;
  z-index: 100;
  display: flex;
  align-items: center;

  .line {
    border-right: 1px solid #eee;
    height: 20px;
    margin: 2px 10px;
  }
  i:nth-child(1) {
    font-size: 20px;
  }
}
@font-face {
  font-family: "iconfont";
  /* Project id 3124047 */
  src: url("//at.alicdn.com/t/font_3124047_5t09q4mrxsw.woff2?t=1647597818102")
      format("woff2"),
    url("//at.alicdn.com/t/font_3124047_5t09q4mrxsw.woff?t=1647597818102")
      format("woff"),
    url("//at.alicdn.com/t/font_3124047_5t09q4mrxsw.ttf?t=1647597818102")
      format("truetype");
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-xiaochengxufenxiang:before {
  content: "\e675";
}
.icon-xiaochengxu-guanbi:before {
  content: "\e68c";
}
</style>